export default "__VITE_ASSET__DgKxS$79__"